import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ConfigurationDataProvider } from '../configuration-data-provider';
import { SharedDataProvider } from '../shared-data-provider';
import { Article } from '../dto/article';

/*
  Generated class for the ArticleProvider provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular 2 DI.
*/
@Injectable()
export class ArticleProvider {
  headers = new HttpHeaders({
    'Content-Type': 'application/json'
  });

  private getAuthHeader(): any {
    let headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'X-pePeLo-Auth': JSON.stringify(this.shared.getTokenAuthData())
    });
    return headers;
  }

  constructor(private http: HttpClient, private config: ConfigurationDataProvider, private shared: SharedDataProvider) { }

  /**
   * List all articles which belong to loggedin user.
   */
  public list() {
    console.log(JSON.stringify(this.shared.getTokenAuthData()));
    return this.http.post(this.config.articleURL + "list", JSON.stringify(this.shared.getTokenAuthData()), { headers: this.getAuthHeader() });
  }

  public save(article: Article) {
    console.log('Push article to insert method of service.');
    article.credentials = this.shared.getTokenAuthData();
    console.log(JSON.stringify(article));
    return this.http.post(this.config.articleURL + "new", JSON.stringify(article), { headers: this.getAuthHeader() });
  }

  public update(article: Article) {
    console.log('Push article to insert method of service.');
    article.credentials = this.shared.getTokenAuthData();
    console.log(JSON.stringify(article));
    return this.http.put(this.config.articleURL + "id/" + article.id, JSON.stringify(article), { headers: this.getAuthHeader() });
  }

  public qryArticle(id: number) {
    return this.http.post(this.config.articleURL + "id/" + id,
      JSON.stringify(this.shared.getTokenAuthData()), { headers: this.getAuthHeader() });
  }

  public delete(id: number) {
    console.log('Delete article ' + id);
    return this.http.post(this.config.articleURL + "del/" + id,
      JSON.stringify(this.shared.getTokenAuthData()), { headers: this.getAuthHeader() });
  }

  public qryArticleNumber(number: string) {
    console.log('Qry articlenumber ' + number);
    return this.http.get(this.config.articleURL + "number/" + number, { headers: this.getAuthHeader() });
  }
}



// WEBPACK FOOTER //
// ./src/providers/article/article.ts